<iot-platform-ui-simple-card [actions]="actions()" [cssClasses]="cssClasses()" [element]="element()" [icon]="icon()"
                             [withMenu]="false"
                             class="card">
  <iot-platform-ui-contact-card
    (delete)="onDelete()"
    (toEdit)="onEdit()"
    [canUpdate]="canUpdateSite && canUpdate"
    [contact]="element()"
    [minimalDisplay]="true"
    cardContent
    class="card__contact"
    fxLayout="column"
  >
  </iot-platform-ui-contact-card>
</iot-platform-ui-simple-card>
